<template>
  <div class="contenedor-difusion">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Crear Mentoreado</h1>
        <div class="barra"></div>
      </div>
      <section class="contenedor-login">
        <div class="contenedor-difusion-imagen">
          <img src="@/assets/geetaji.jpg" alt="Geeta Iyengar">
        </div>
        <div class="contenedor-difusion-text">
          <p>Estimados profesores,</p>

          <p>Aquí encuentran el Formulario para inscribir a las personas que inician la Mentoría bajo su guía.</p>

          <p>La mentoría queda registrada desde que este formulario se completa y llega un email formal de CMC con la confirmacion correspondiente, antes de hacerlo el CMC chequeara con Tesoreria que el mentoreado sea socio y con la cuota al dia de la AAYI ( requsito excluyente )</p>

          <p>IMPORTANTE: </p>
          <ul class="lista_precios_seminario">
            <li><b>⚬ </b>Para presentar a alguien a la Certificación, se requieren 2 (dos) años en el Registro Nacional de Mentorías.</li>
            <li><b>⚬ </b>El límite de mentoreados es de 8 candidatos por mentor.</li>
            <li><b>⚬ </b>La fecha de inicio formal de la mentoria es la fecha en que se envia este formulario, sin excepción.</li>
            <li><b>⚬ </b>El Comité de mentorías y certificación enviará un email de confirmación al mentor y mentoreado, luego de que llegue la inscripción.</li>
          </ul>
          <form
            action="#"
            method="post"
            @submit.prevent="crearMentor(mentor)"
            class="form_presupuesto_nuevo"
          >
            <div class="form_section">
              <label for="alumno_id">Persona</label>
              <v-select
                class="contenedor_select_buscador"
                v-model="mentor.alumno_id"
                label="item_data"
                :reduce="socios => socios.persona_id"
                :options="socios"
                :disabled="cargando"
              >
                <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                  <p>La persona ingresada no figura en nuestros registros.</p>
                </span>
              </v-select>
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.alumno_id !== null"
              >
                {{ errores.alumno_id[0] }}
              </div>
            </div>
            <!-- <div class="form_section">
              <label for="fecha_inicio">Fecha de Inicio</label>
              <input
                type="date"
                name="fecha_inicio"
                id="fecha_inicio"
                v-model="mentor.fecha_inicio"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.fecha_inicio !== null"
              >
                {{ errores.fecha_inicio[0] }}
              </div>
            </div> -->
            <div class="form_section">
              <label for="tiempo_toma_clase">¿Hace cuanto toma clase de Yoga Iyengar?</label>
              <input
                type="text"
                name="tiempo_toma_clase"
                id="tiempo_toma_clase"
                v-model="mentor.tiempo_toma_clase"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.tiempo_toma_clase !== null"
              >
                {{ errores.tiempo_toma_clase[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="tiempo_toma_clase_mentor">¿Hace cuanto toma clases con su mentor?</label>
              <input
                type="text"
                name="tiempo_toma_clase_mentor"
                id="tiempo_toma_clase_mentor"
                v-model="mentor.tiempo_toma_clase_mentor"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.tiempo_toma_clase_mentor !== null"
              >
                {{ errores.tiempo_toma_clase_mentor[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="cuantas_clases_semanales">¿Cuantas clases semanales toma?</label>
              <input
                type="text"
                name="cuantas_clases_semanales"
                id="cuantas_clases_semanales"
                v-model="mentor.cuantas_clases_semanales"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.cuantas_clases_semanales !== null"
              >
                {{ errores.cuantas_clases_semanales[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="formato_clase_mentor">¿Toma clases en formato online o presencial con el mentor?</label>
              <input
                type="text"
                name="formato_clase_mentor"
                id="formato_clase_mentor"
                v-model="mentor.formato_clase_mentor"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.formato_clase_mentor !== null"
              >
                {{ errores.formato_clase_mentor[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="clases_presenciales_ciudad">En caso de tomar clases regulares online con el mentor, ¿Toma clases presenciales con algún profesor certificado en su ciudad?</label>
              <input
                type="text"
                name="clases_presenciales_ciudad"
                id="clases_presenciales_ciudad"
                v-model="mentor.clases_presenciales_ciudad"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.clases_presenciales_ciudad !== null"
              >
                {{ errores.clases_presenciales_ciudad[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="porque_no">Si la respuesta fue no, especificar por qué (aclarar si no hay profesores certificados en el lugar de residencia del mentoreado)</label>
              <input
                type="text"
                name="porque_no"
                id="porque_no"
                v-model="mentor.porque_no"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.porque_no !== null"
              >
                {{ errores.porque_no[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="cuantas_clases_dicta">¿Cuantas clases semanles enseña?</label>
              <input
                type="text"
                name="cuantas_clases_dicta"
                id="cuantas_clases_dicta"
                v-model="mentor.cuantas_clases_dicta"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.cuantas_clases_dicta !== null"
              >
                {{ errores.cuantas_clases_dicta[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="formacion_anterior">¿Tiene una formación anterior? Especificar</label>
              <input
                type="text"
                name="formacion_anterior"
                id="formacion_anterior"
                v-model="mentor.formacion_anterior"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.formacion_anterior !== null"
              >
                {{ errores.formacion_anterior[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="observaciones">Observaciones y consideraciones sobre el mentoreado.</label>
              <textarea
                name="observaciones"
                id="observaciones"
                v-model.number="mentor.observaciones"
              ></textarea>
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.observaciones !== null"
              >
                {{ errores.observaciones[0] }}
              </div>
            </div>
            <button type="submit" class="boton_guardar">Crear Mentoreado</button>
          </form>
        </div>
      </section>
    </section>
  </div>
</template>
<script src="https://unpkg.com/vue@2"></script>
<script src="https://unpkg.com/vue-select@latest"></script>
<script>
import 'vue-select/dist/vue-select.css';
// import pagosService from '../services/pagos'
import mentorService from '../services/mentor'
import asociadoService from '../services/asociado'
import store from './../store'

export default {
  name: 'CrearMentoreado',
  components: {
  },
  data: function () {
    return {
      options: [
        'foo',
        'bar',
        'baz'
      ],
      count: 1,
      conceptos: [],
      cuotasSelect: [],
      socios: [],
      servicios: [],
      formasDePago: [],
      monedas: [],
      years: [],
      personas: [],
      cargando: false,
      mentor: {
        certificacion_id: null,
        alumno_id: null,
        mentor_id: JSON.parse(localStorage.getItem('userData')).persona_id,
        // fecha_inicio: null,
        tiempo_toma_clase: null,
        tiempo_toma_clase_mentor: null,
        cuantas_clases_semanales: null,
        formato_clase_mentor: null,
        clases_presenciales_ciudad: null,
        porque_no: null,
        cuantas_clases_dicta: null,
        formacion_anterior: null,
        observaciones: null
      },
      errores: {
        alumno_id: null,
        mentor_id: null,
        // fecha_inicio: null,
        tiempo_toma_clase: null,
        tiempo_toma_clase_mentor: null,
        cuantas_clases_semanales: null,
        formato_clase_mentor: null,
        clases_presenciales_ciudad: null,
        porque_no: null,
        cuantas_clases_dicta: null,
        formacion_anterior: null,
        observaciones: null
      },
      store
    }
  },
  methods: {
    // addComponent () {
    //   this.count += 1
    //   console.log(this.servicio.productos.push({
    //     servicio_id: null,
    //     precio: null,
    //     cantidad: null
    //   }))
    // },
    // onChange (event) {
      // console.log(numero)
      // console.log(event.target.value)
      // console.log(event.target.name)
      // console.log(document.getElementsByClassName('year'))
      // if (event.target.value === '1' || event.target.value === '2' || event.target.value === '3' || event.target.value === '4') {
      //   console.log(event.target.value)
      //   document.getElementById('cuota').style.display = 'flex'
      // } else {
      //   document.getElementById('cuota').style.display = 'none'
      // }
      // if (event.target.value != null) {
      //   console.log(event.target.value)

      //   document.getElementById('cuota').style.display = 'flex'
      //   serviciosService
      //     .listarServicioConCuotasPorId(event.target.value)
      //     .then(respuesta => {
      //       // this.cargando = false
      //       this.cuotasSelect = respuesta
      //       console.log('ServicioConInfo: ', respuesta)
      //     })

      // }
      // console.log(this.productos[event.target.value - 1].precio)
      // // document.getElementsByName('precio-' + numero)[0].value = this.productos[event.target.value - 1].precio
      // this.servicio.productos[numero - 1].precio = this.productos[event.target.value - 1].precio
    // },
    crearMentor (mentor) {
      console.log('qqqq')
      console.log(mentor)
      if (this.cargando) {
        return null
      }
      this.cargando = true
      mentorService
        .crearMentor(mentor)
        .then(respuesta => {
          this.cargando = false
          if (respuesta.success) {
            console.log('SIIIIII')
            this.mentor = {
              certificacion_id: null,
              alumno_id: null,
              mentor_id: JSON.parse(localStorage.getItem('userData')).persona_id,
              // fecha_inicio: null,
              tiempo_toma_clase: null,
              tiempo_toma_clase_mentor: null,
              cuantas_clases_semanales: null,
              formato_clase_mentor: null,
              clases_presenciales_ciudad: null,
              porque_no: null,
              cuantas_clases_dicta: null,
              formacion_anterior: null,
              observaciones: null
            }
            this.errores = {
              alumno_id: null,
              mentor_id: null,
              // fecha_inicio: null,
              tiempo_toma_clase: null,
              tiempo_toma_clase_mentor: null,
              cuantas_clases_semanales: null,
              formato_clase_mentor: null,
              clases_presenciales_ciudad: null,
              porque_no: null,
              cuantas_clases_dicta: null,
              formacion_anterior: null,
              observaciones: null
            }
            // this.store.setStatus({
            //   msg: 'El pago se creo exitosamente',
            //   type: 'success'
            // })
            this.$router.push('/mentorias')
          } else {
            this.errores = {
              alumno_id: null,
              mentor_id: null,
              // fecha_inicio: null,
              tiempo_toma_clase: null,
              tiempo_toma_clase_mentor: null,
              cuantas_clases_semanales: null,
              formato_clase_mentor: null,
              clases_presenciales_ciudad: null,
              porque_no: null,
              cuantas_clases_dicta: null,
              formacion_anterior: null,
              observaciones: null,
              ...respuesta.errors
            }
          }
        })
    }
  },
  mounted: function () {
    // serviciosService
    //   .traerServiciosTodos()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.servicios = respuesta.reverse()
    //     console.log('Servicios: ', respuesta)
    //   })
    // pagosService
    //   .traerPersonas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.personas = respuesta
    //     console.log('Personas: ', respuesta)
    //     this.personas.map(function (x){
    //       return x.item_data = x.nombre + ' ' + x.apellido;
    //     })
    //     console.log('Personaseeeee: ', respuesta)
    //   })
    asociadoService
      .listadoSociosSelect()
      .then(respuesta => {
        // this.cargando = false
        this.socios = respuesta
        console.log('listadoSociosSelect:', respuesta)
        this.socios.map(function (x) {
          // const pepe = x.nombre + ' ' + x.apellido
          // console.log(pepe)
          x.item_data = x.nombre + ' ' + x.apellido
          // return x.item_data = pepe
        })
      })
    // pagosService
    //   .traerConceptosDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.conceptos = respuesta
    //     console.log('Conceptos: ', respuesta)
    //   })
    // pagosService
    //   .traerFormasDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.formasDePago = respuesta
    //     console.log('Formas de Pago: ', respuesta)
    //   })
    // pagosService
    //   .traerMonedas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.monedas = respuesta
    //     console.log('Monedas: ', respuesta)
    //   })
    // pagosService
    //   .traerYearsDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.years = respuesta
    //     console.log('Years: ', respuesta)
    //   })
    // personasService
    //   .traerCertificacionesTodas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.certificaciones = respuesta
    //   })
    // pagosService
    //   .traerFormasDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.formasDePago = respuesta
    //   })
    // pagosService
    //   .traerMonedas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.monedas = respuesta
    //   })
    // pagosService
    //   .traerPersonas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.personas = respuesta
    //     console.log('Personas: ', respuesta)
    //   })
  }
}
</script>
<style>
#cuota {
  display: none;
}
.select_buscador {
  flex: 1;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: black;
  margin: 10px 0;
}

.vs__selected-options {
/*  padding: 0 12px !important;*/
  position: relative;
}
.vs__search {
  border: none !important;
/*  border: 2px solid red !important;*/
  margin: 0 !important;
  height: 45px !important;
}
.vs--single .vs__selected {
  width: 100% !important;
  font-size: 1em;
}
.vs__selected {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 12px !important;
  color: black !important;
  margin: 12px 0 7px !important;
}
.vs__dropdown-toggle {
  padding: 0 !important;
}

.vs__clear {
/*  display: none;*/
}

.vs__open-indicator {
  display: none;
}

</style>
